"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNotificationMessageBodySchema = exports.ListRecipientsResponseSchema = exports.RecipientSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.RecipientSchema = (0, core_1.StrictObject)({
    user: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        email: typebox_1.Type.Optional(core_1.EmailSchema),
        name: core_1.NameSchema,
    }),
    email: typebox_1.Type.Boolean(),
});
exports.ListRecipientsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.RecipientSchema);
exports.CreateNotificationMessageBodySchema = ruby_1.NotificationMessageSchema;
